import React from 'react';
import './style.scss';
import Button from '../Shared/components/controls/Button';
import clsx from 'clsx';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const GlobalMessageComponent = (props) => {
  // In case the BE didn't provide appropriate data we'll render a dummy placeholder
  if (!props?.fields || !props?.params)
    return <GenericPlaceholder componentName="GlobalMessageComponent" />;
  const {
    title: subheading,
    text: heading,
    icon,
    image,
    title2,
    text2,
    icon2,
    link,
  } = props?.fields;

  const { params } = props;
  // Conditional rendering
  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderIcon = !!icon?.value?.src;
  const shouldRenderIcon2 = !!icon2?.value?.src;
  const shouldRenderSubheading = !!subheading?.value;
  const shouldRenderHeading = !!heading?.value;
  const shouldRenderTile2 = !!title2?.value;
  const shouldRenderText2 = !!text2?.value;
  const shouldRenderLink = !!link?.value?.href;

  return (
    <div className={clsx('global-message align-center', 'add-margins', params?.Styles)}>
      <div className="panel left content-left">
        {shouldRenderImage && (
          <div className="image-layer">
            <Image field={image} />
          </div>
        )}

        <div className="wrap-data">
          <div className="wrap flex-it flex-align-item-center flex-justify-start">
            <div className="auto">
              {shouldRenderSubheading && (
                <span className="title">
                  <Text field={subheading} />
                </span>
              )}
              {shouldRenderHeading && <RichText className="description" field={heading} />}
            </div>
          </div>
          {shouldRenderIcon && (
            <div className="head">
              <Image field={icon} className="logo" />
            </div>
          )}
        </div>
      </div>

      <div className="panel right">
        <div className="wrap flex-it_ flex-align-item-center_ flex-justify-center_">
          <table className="fullTable">
            <tbody>
              <tr valign="middle">
                <td>
                  <div className="auto">
                    {shouldRenderIcon2 && <Image field={icon2} className="logo" />}
                    {shouldRenderTile2 && <RichText className="title" field={title2} />}
                    {shouldRenderText2 && <RichText className="description" field={text2} />}
                    {shouldRenderLink && (
                      <Button
                        variant="contained"
                        className="panel-right__link"
                        link={link}
                        fullWidth={true}
                      />
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GlobalMessageComponent;
